// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-3a349aa3]{height:1px;background-position:0 100%;background-size:4px 1px;background-repeat:repeat-x;-ms-interpolation-mode:nearest-neighbor;image-rendering:-moz-crisp-edges;image-rendering:pixelated}", ""]);
// Exports
module.exports = exports;
